<script setup lang="ts">
const emit= defineEmits(['on-close'])
const props=defineProps({
  'title':String,
})

const onClose = ()=>{
  emit('on-close')

}
</script>
<template>
  <div class="flex justify-space-between mb-4">
    <div class="responsive-title-6 font-semibold">{{ props.title }}</div>
    <div class="cursor-pointer flex justify-end  place-items-end close-div" type="default"
         @click.stop="onClose">
      <img src="@/assets/icons/svg/Close_16x16.svg" alt="Close" width="18"/>
    </div>
  </div>
</template>